import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { InvestSimulation } from '@classes/invest/invest-simulation/invest-simulation';
import { InvestService } from '@services/invest.service';
import { FormatService } from '@services/format.service';
import { InvestYear } from '@classes/invest/invest-simulation/invest-year';

@Component({
    selector: 'app-bbc-datatable',
    templateUrl: './bbc-datatable.component.html',
    styleUrls: ['./bbc-datatable.component.scss']
})
export class BbcDatatableComponent implements OnInit, OnDestroy {
    // used from live simulator to show datatable only
    @Input() simulation: InvestSimulation;

    private investSub: Subscription;

    budgetResCode = 'bbc2020.beschikbaarBudgettairResultaat';
    afmCode = 'bbc2020.afm';

    constructor(
        private investSrv: InvestService,
        private formatSrv: FormatService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    parseValue(inputValue: string): number {
        const value = this.formatSrv.stringToFloat(inputValue);

        return value != null ? value : 0;
    }

    checkError(year: InvestYear, code: string, min: number): boolean {
        const value = this.getItemValue(year, code);

        switch(code) {
            case this.budgetResCode:
            case this.afmCode:
                return value < min;
            default:
                return false;
        }
    }

    getItemValue(year: InvestYear, code: string): number {
        const item = year.items.find(i => i.code === code);

        return item ? item.value :  null;
    }

    private initSubscriptions(): void {
        this.investSub = this.investSrv.investChanged
        .subscribe(invest => {
            if(invest) {
                // this.invest = this.investSrv.calculateBbcTots(invest);
                this.simulation = invest.simulation;
            }
        });
    }

    ngOnDestroy(): void {
        if(this.investSub) {
            this.investSub.unsubscribe();
        }
    }
}
